import { Input } from 'antd';
import Box from 'components/Box';
import DatePickerPeriod from 'components/DatePickerPeriod';
import SegmentedTime from 'components/SegmentedTime';
import Text from 'components/Text';
import { DATE_FORMAT } from 'features/appointment/utils/format';
import { CALENDAR_PICKER_TYPE } from 'features/settingStaff/services/constants';
import ticketListActions from 'features/ticketList/services/actions';
import AddCloseTicket from 'features/ticketList/widgets/AddCloseTicket';
import { debounce, isArray } from 'lodash';
import moment, { Moment } from 'moment';
import { RangeValue } from 'rc-picker/lib/interface';
import React, { useState } from 'react';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
type IHeaderTicketsProps = {
  isCreditPage?: boolean;
};

const HeaderTickets: React.FC<IHeaderTicketsProps> = ({ isCreditPage }) => {
  const dispatch = useAppDispatch();
  const [viewType, setViewType] = useState<string | number>(
    CALENDAR_PICKER_TYPE.DATE
  );

  const debouncedHandleChange = debounce((value: string) => {
    const params = {
      ticketNumber: value,
    };
    dispatch(ticketListActions.setTicketsParams(params));
  }, 300); // 300ms delay

  const convertStartEndDate = (date: moment.Moment, type: string | number) => {
    switch (type) {
      case 'week': {
        const startDate = date.startOf('week').format(DATE_FORMAT);
        const endDate = date.endOf('week').format(DATE_FORMAT);
        return {
          startDate,
          endDate,
        };
      }

      case 'month': {
        const startDate = date.startOf('month').format(DATE_FORMAT);
        const endDate = date.endOf('month').format(DATE_FORMAT);
        return {
          startDate,
          endDate,
        };
      }

      default: {
        const startDate = moment(date).format(DATE_FORMAT);
        const endDate = moment(date).format(DATE_FORMAT);
        return {
          startDate,
          endDate,
        };
      }
    }
  };

  const handleChangeDate = (date: Moment | RangeValue<Moment>) => {
    if (viewType == CALENDAR_PICKER_TYPE.WEEK && isArray(date) || isArray(date)) {
      const params = {
        startDate: moment(date?.[0]).format(DATE_FORMAT),
        endDate: moment(date?.[1]).format(DATE_FORMAT),
        date: moment(date?.[0]).format(DATE_FORMAT),
        page: 1,
      };
      dispatch(ticketListActions.setTicketsParams(params));
    } else {
      const formattedDate = moment(date).format(DATE_FORMAT);
      if (date) {
        const dateConvert = convertStartEndDate(date, viewType);
        const params = {
          startDate: dateConvert.startDate,
          endDate: dateConvert.endDate,
          date: formattedDate,
          page: 1,
        };
        dispatch(ticketListActions.setTicketsParams(params));
      }
    }
  };

  const handleChangeTypeView = (type: string | number) => {
    const date = moment();
    setViewType(type);
    const params = {
      startDate: convertStartEndDate(date, type).startDate,
      endDate: convertStartEndDate(date, type).endDate,
      date: date.format('MM-DD-YYYY'),
      page: 1,
    };
    dispatch(ticketListActions.setTicketsParams(params));
  };

  const onAddCloseTicketMutate = (date: Moment) => {
    const type = 'date';
    setViewType(type);
    const params = {
      startDate: convertStartEndDate(date, type).startDate,
      endDate: convertStartEndDate(date, type).endDate,
      date: date.format('MM-DD-YYYY'),
      page: 1,
    };
    dispatch(ticketListActions.setTicketsParams(params));
  };

  return (
    <HeaderTicketsStyled>
      {!isCreditPage && (
        <Box mr='2'>
          <Text variant='H5'>Closed Tickets</Text>
        </Box>
      )}
      <FilterGroupStyled>
        <TicketNumberInput>
          <Input
            className='ticketNumberInput'
            placeholder='Ticket No.'
            type='number'
            onChange={(e) => {
              debouncedHandleChange(e.target.value);
            }}
          />
        </TicketNumberInput>

        <Box display='flex' gap='2'>
          <DatePickerPeriod
            onChange={handleChangeDate}
            picker={viewType as CALENDAR_PICKER_TYPE}
          />
          <SegmentedTime value={viewType} handleChange={handleChangeTypeView} />
        </Box>
        <AddCloseTicket mutate={onAddCloseTicketMutate} />
      </FilterGroupStyled>
    </HeaderTicketsStyled>
  );
};

export default HeaderTickets;
const HeaderTicketsStyled = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding-top: 1.5rem;
`;
const TicketNumberInput = styled.div`
  width: 13rem;
  .ticketNumberInput {
    height: 3.5rem;
  }
`;

const FilterGroupStyled = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
`;
